// AI Generated File
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { StateService } from '@uirouter/core';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'ignored-misspellings',
    standalone: false,
    template: `
        <page-header
                [icon]="['QA', 'DICTIONARY'] | monIcons"
                [header]="'Ignored Misspellings' | translate"
                [subHeader]="subheaderTranslation">
        </page-header>
        <mon-tabs
                [options]="tabs"
                [(status)]="activeTab"
                (onStatus)="onStatus($event)"
                (onSearch)="onSearch($event)"
                [search]="search"
                [minSearchLength]="1"
                [maxOptionsDisplay]="6"
                [showSearch]="true">
                <csv-export-button [exports]="exports"></csv-export-button>
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <div class="px-4">
                    <table-container
                            [collection]="misspellings"
                            [noResultMessage]="'No misspellings have been ignored' | translate"
                            (onPageChange)="onPageChange($event)"
                            (onPerPageChange)="onPageSizeChange($event)"
                            class="table-vertial-align"
                            [progress]="promise">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th class="col-sm-20 col-md-20 col-lg-20" translate>Word</th>
                                    <th class="text-right col-sm-5 col-md-5 col-lg-4" translate>Language</th>
                                    <th class="text-right" translate>Ignored date</th>
                                    <th class="text-right" translate>Ignored by</th>
                                    <th class="text-right col-sm-5 col-md-5 col-lg-8" translate>Remove from Ignored</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let word of misspellings; trackBy: trackById">
                                    <td>{{ word.word }}</td>
                                    <td class="text-right"><language [language]="word.language"></language></td>
                                    <td class="text-right"><user-date [date]="word.created_at"></user-date></td>
                                    <td class="text-right">
                                        {{ word.added_by?.first_name }} {{ word.added_by?.last_name }}
                                    </td>
                                    <td class="text-right">
                                        <span
                                                role="button"
                                                [attr.aria-label]="'Remove this word from Ignored Misspellings' | translate"
                                                class="btn btn-border-radius btn-link"
                                                ngbTooltip="{{ 'Remove word from Ignored Misspellings' | translate }}"
                                                [triggers]="'focus hover'"
                                                [placement]="'bottom'"
                                                [monModalConfirm]=" 'Are you sure you want to remove the word <strong>' + word.word + '</strong> from the Ignored Misspellings? <br />' +
                                                                   'Please note, the misspelling will first show up after a new scan' | translate "
                                                (monModalConfirmAction)="removeWord(word)"
                                                monEventTrigger="actionTrigger"
                                                [monEventParams]="{action:'spellcheck-remove-from-ignored-misspellings'}"
                                        >
                                            {{ 'Unignore Misspelling' | translate }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class IgnoredMisspellingsComponent extends BaseContainerComponentController implements OnInit {
    misspellings: any = [];
    tabs: any = [];
    subheaderTranslation: string = '';
    exports: any = [];
    type: any = null;
    domainId: any;
    promise: any;

    constructor (
        private translateService: TranslateService,
        private stateService: StateService,
    ) {
        super({ table: true });
    }

    ngOnInit () {
        this.search = '';
        this.type = null;
        this.domainId = this.stateService.params.domainId;
        this.misspellings = [];
        this.tabs = [{ name: this.translateService.getString('All'), faIcon: 'fas fa-language', value: 'all' }];
        this.activeTab = this.tabs[0].value;
        this.subheaderTranslation = '';
        this.exports = [
            {
                name: this.translateService.getString('Ignored Misspellings'),
                data: {
                    category: 'account_dictionary_ignored',
                },
            },
        ];

        this.spellingRepoService.getAllLanguages({ domain_id: this.stateService.params.domainId }).then((data: any) => {
            data.forEach((item: any) => {
                this.tabs.push({
                    name: this.pipeService.get('translateLanguage')(item.lang),
                    faIcon: 'fas fa-language',
                    value: item.lang,
                });
            });
        }, () => {});

        this.getPage();
    }

    override getPage = () => {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            language: this.activeTab === 'all' ? null : this.activeTab,
            type: 'ignore',
            domainId: this.domainId,
            search: this.search,
        };
        this.promise = this.spellingRepoService.getAllIgnoredSpellingErrors(params).then((data: any) => {
            this.misspellings = data;
            this.getSubHeaderDescription();
        }, () => {});
    };

    getSubHeaderDescription () {
        this.subheaderTranslation = this.translateService.getPlural(
            this.pipeService.get('monNumber')(this.misspellings.total, '0,0'),
            '1 misspelling ignored across all domains',
            '[[$count]] misspellings added across all domains',
            {},
            '',
        );
    }

    removeWord (word: any) {
        this.spellingRepoService.destroyWord(word.id).then(() => {
            this.getPage();
        }, () => {});
    }

    trackById (index: number, item: any) {
        return item.id;
    }
}
